import {
  Box,
  Container,
  Heading,
  Image,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";
import DCLogo from "../../../resources/images/dc_comics.svg";
import ImageLogo from "../../../resources/images/image.svg";
import MarvelLogo from "../../../resources/images/marvel.svg";
import StarWarsLogo from "../../../resources/images/star_wars.svg";
import { getLastReading } from "../../../services/readingOrdersApi";
import ReadingCard from "../components/ReadingCard";
import ReadingList from "../components/ReadingList";
import {
  getReadingTabIndexFromFranchise,
  getStoredReadingTabIndex,
  persistReadingTabIndex,
} from "../readingTabStorage";

const Reading = () => {
  const location = useLocation();
  const routeTabIndex = getReadingTabIndexFromFranchise(
    location?.state?.franchiseTab
  );
  const [tabIndex, setTabIndex] = useState(getStoredReadingTabIndex);
  const { isLoading, data } = useQuery(["lastRead"], getLastReading);

  useEffect(() => {
    if (routeTabIndex !== null) {
      setTabIndex(routeTabIndex);
      persistReadingTabIndex(routeTabIndex);
    }
  }, [routeTabIndex]);

  const onTabChange = (index) => {
    setTabIndex(index);
    persistReadingTabIndex(index);
  };

  return (
    <Container>
      <Heading as="h2" my="6">
        My Reading
      </Heading>

      {!isLoading && !!data.data && (
        <Box>
          <Text fontSize="sm" color="gray.400" mt="6" mb="2" casing="uppercase">
            CONTINUE READING
          </Text>
          <ReadingCard
            key={data.data.id}
            url={`/reading/${data.data.id}`}
            reading={{
              ...data.data,
              readingOrder: {
                ...data.data.readingOrder,
                comicsCount: data.data.totalComics,
              },
            }}
            progress={data.data?.progress}
          />
        </Box>
      )}

      <Tabs index={tabIndex} onChange={onTabChange} isLazy>
        <TabList>
          <Tab>
            <Image src={MarvelLogo} height={30} />
          </Tab>
          <Tab>
            <Image src={DCLogo} height={30} />
          </Tab>
          <Tab>
            <Image src={StarWarsLogo} height={45} />
          </Tab>
          <Tab>
            <Image src={ImageLogo} height={29} />
          </Tab>
        </TabList>
        <TabPanels>
          {/* initially mounted */}
          <TabPanel>
            <ReadingList franchise={1} />
          </TabPanel>
          {/* initially not mounted */}
          <TabPanel>
            <ReadingList franchise={2} />
          </TabPanel>
          <TabPanel>
            <ReadingList franchise={3} />
          </TabPanel>
          <TabPanel>
            <ReadingList franchise={4} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  );
};

export default Reading;
